import { AbiItem } from 'web3-utils'
import { 
  getFarmVotingAddress, getRanchFactoryAddress, getIboV2FactoryAddress, getAirdropperAddress,
  getCandyHouseAddress, getEbenGovAddress, getNftFactorySingleAddress, getCharitiesAddress,
  getNftFactorySeriesAddress,
  getNftBasicAddress,
  getAntAgingPillsAddress
} from 'utils/addressHelpers'
import ranchFactory from 'config/abi/ranchFactory.json'
import ranch from 'config/abi/ranch.json'
import iboV2Factory from 'config/abi/iboV2Factory.json'
import iboV2 from 'config/abi/iboV2.json'
import candy from 'config/abi/candy.json'
import candyhouse from 'config/abi/candyhouse.json'
import ebenGov from 'config/abi/ebenGov.json'
import airdropper from 'config/abi/airdropper.json'
import farmVoting from 'config/abi/farmvoting.json'
import nftFactorySingle from 'config/abi/nftFactorySingle.json'
import charities from 'config/abi/charities.json'
import blindBoxes from 'config/abi/blindBoxes.json'
import islandGame from 'config/abi/islandGame.json'
import nftFactorySeries from 'config/abi/nftFactorySeries.json'
import abiNftFactorySeriesBasic  from 'config/abi/nftFactorySeriesBasic.json';
import abiNftFactorySeriesSimple  from 'config/abi/nftFactorySeriesSimple.json';
import abiAntAgingPills from 'config/abi/AntAgingPills.json';

import { useContract } from './useContract'

export const useRanchFactory = () => {
  const abi = (ranchFactory as unknown) as AbiItem
  return useContract(abi, getRanchFactoryAddress())
}

export const useRanch = (address: string) => {
  const abi = (ranch as unknown) as AbiItem
  return useContract(abi, address)
}

export const useIboV2Factory = () => {
  const abi = (iboV2Factory as unknown) as AbiItem
  return useContract(abi, getIboV2FactoryAddress())
}

export const useIboV2 = (address: string) => {
  const abi = (iboV2 as unknown) as AbiItem
  return useContract(abi, address)
}

export const useCandyHouse = () => {
  const abi = (candyhouse as unknown) as AbiItem
  return useContract(abi, getCandyHouseAddress())
}

export const useCandy = (address: string) => {
  const abi = (candy as unknown) as AbiItem
  return useContract(abi, address)
}

export const useEbenGov = () => {
  const abi = (ebenGov as unknown) as AbiItem
  return useContract(abi, getEbenGovAddress())
}

export const useAirdropper = () => {
  const abi = (airdropper as unknown) as AbiItem
  return useContract(abi, getAirdropperAddress())
}

export const useFarmVoting = () => {
  const abi = (farmVoting as unknown) as AbiItem
  return useContract(abi, getFarmVotingAddress())
}

export const useNftFactorySingle = () => {
  const abi = (nftFactorySingle as unknown) as AbiItem
  return useContract(abi, getNftFactorySingleAddress())
}

export const useCharitiesContract = () => {
  const abi = (charities as unknown) as AbiItem
  return useContract(abi, getCharitiesAddress())
}

export const useBindBoxesContract = (contractAddress:string) => {
  const abi = (blindBoxes as unknown) as AbiItem
  return useContract(abi, contractAddress)
}

export const useIslandGameContract = (contractAddress:string) => {
  const abi = (islandGame as unknown) as AbiItem
  return useContract(abi, contractAddress)
}

export const useNftFactorySeries = () => {
  const abi = (nftFactorySeries as unknown) as AbiItem
  return useContract(abi, getNftFactorySeriesAddress())
}

export const useNftFactorySeriesBasic = (address: string) => {
  const abi = (abiNftFactorySeriesBasic as unknown) as AbiItem
  return useContract(abi, address)
}

export const useNftFactorySeriesSimple = (address: string) => {
  const abi = (abiNftFactorySeriesSimple as unknown) as AbiItem
  return useContract(abi, address)
}
export const useAntAgingPills = () => {
  const abi = (abiAntAgingPills as unknown) as AbiItem
  return useContract(abi, getAntAgingPillsAddress())
}


export default useContract
